module.exports = __webpack_public_path__ + "assets/b8dd3c081bc7917b47866c5fd413b10a.png";